/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as TagsRouteImport } from './routes/tags'
import { Route as SongsRouteImport } from './routes/songs'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as PolicyRouteImport } from './routes/policy'
import { Route as OpsRouteImport } from './routes/ops'
import { Route as LoginRouteImport } from './routes/login'
import { Route as FlagsRouteImport } from './routes/flags'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as EntitlementsRouteImport } from './routes/entitlements'
import { Route as BadgeCopyRouteImport } from './routes/badge-copy'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as AttributionDisputesRouteImport } from './routes/attribution-disputes'
import { Route as AnnouncementsRouteImport } from './routes/announcements'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as IndexRouteImport } from './routes/index'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const TagsRoute = TagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => rootRouteImport,
} as any)
const SongsRoute = SongsRouteImport.update({
  id: '/songs',
  path: '/songs',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewsRoute = ReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const PolicyRoute = PolicyRouteImport.update({
  id: '/policy',
  path: '/policy',
  getParentRoute: () => rootRouteImport,
} as any)
const OpsRoute = OpsRouteImport.update({
  id: '/ops',
  path: '/ops',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const FlagsRoute = FlagsRouteImport.update({
  id: '/flags',
  path: '/flags',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackRoute = FeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const EntitlementsRoute = EntitlementsRouteImport.update({
  id: '/entitlements',
  path: '/entitlements',
  getParentRoute: () => rootRouteImport,
} as any)
const BadgeCopyRoute = BadgeCopyRouteImport.update({
  id: '/badge-copy',
  path: '/badge-copy',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const AttributionDisputesRoute = AttributionDisputesRouteImport.update({
  id: '/attribution-disputes',
  path: '/attribution-disputes',
  getParentRoute: () => rootRouteImport,
} as any)
const AnnouncementsRoute = AnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/announcements': typeof AnnouncementsRoute
  '/attribution-disputes': typeof AttributionDisputesRoute
  '/audit': typeof AuditRoute
  '/badge-copy': typeof BadgeCopyRoute
  '/entitlements': typeof EntitlementsRoute
  '/faq': typeof FaqRoute
  '/feedback': typeof FeedbackRoute
  '/flags': typeof FlagsRoute
  '/login': typeof LoginRoute
  '/ops': typeof OpsRoute
  '/policy': typeof PolicyRoute
  '/reports': typeof ReportsRoute
  '/reviews': typeof ReviewsRoute
  '/songs': typeof SongsRoute
  '/tags': typeof TagsRoute
  '/users': typeof UsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/announcements': typeof AnnouncementsRoute
  '/attribution-disputes': typeof AttributionDisputesRoute
  '/audit': typeof AuditRoute
  '/badge-copy': typeof BadgeCopyRoute
  '/entitlements': typeof EntitlementsRoute
  '/faq': typeof FaqRoute
  '/feedback': typeof FeedbackRoute
  '/flags': typeof FlagsRoute
  '/login': typeof LoginRoute
  '/ops': typeof OpsRoute
  '/policy': typeof PolicyRoute
  '/reports': typeof ReportsRoute
  '/reviews': typeof ReviewsRoute
  '/songs': typeof SongsRoute
  '/tags': typeof TagsRoute
  '/users': typeof UsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/announcements': typeof AnnouncementsRoute
  '/attribution-disputes': typeof AttributionDisputesRoute
  '/audit': typeof AuditRoute
  '/badge-copy': typeof BadgeCopyRoute
  '/entitlements': typeof EntitlementsRoute
  '/faq': typeof FaqRoute
  '/feedback': typeof FeedbackRoute
  '/flags': typeof FlagsRoute
  '/login': typeof LoginRoute
  '/ops': typeof OpsRoute
  '/policy': typeof PolicyRoute
  '/reports': typeof ReportsRoute
  '/reviews': typeof ReviewsRoute
  '/songs': typeof SongsRoute
  '/tags': typeof TagsRoute
  '/users': typeof UsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/announcements'
    | '/attribution-disputes'
    | '/audit'
    | '/badge-copy'
    | '/entitlements'
    | '/faq'
    | '/feedback'
    | '/flags'
    | '/login'
    | '/ops'
    | '/policy'
    | '/reports'
    | '/reviews'
    | '/songs'
    | '/tags'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/announcements'
    | '/attribution-disputes'
    | '/audit'
    | '/badge-copy'
    | '/entitlements'
    | '/faq'
    | '/feedback'
    | '/flags'
    | '/login'
    | '/ops'
    | '/policy'
    | '/reports'
    | '/reviews'
    | '/songs'
    | '/tags'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/analytics'
    | '/announcements'
    | '/attribution-disputes'
    | '/audit'
    | '/badge-copy'
    | '/entitlements'
    | '/faq'
    | '/feedback'
    | '/flags'
    | '/login'
    | '/ops'
    | '/policy'
    | '/reports'
    | '/reviews'
    | '/songs'
    | '/tags'
    | '/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsRoute: typeof AnalyticsRoute
  AnnouncementsRoute: typeof AnnouncementsRoute
  AttributionDisputesRoute: typeof AttributionDisputesRoute
  AuditRoute: typeof AuditRoute
  BadgeCopyRoute: typeof BadgeCopyRoute
  EntitlementsRoute: typeof EntitlementsRoute
  FaqRoute: typeof FaqRoute
  FeedbackRoute: typeof FeedbackRoute
  FlagsRoute: typeof FlagsRoute
  LoginRoute: typeof LoginRoute
  OpsRoute: typeof OpsRoute
  PolicyRoute: typeof PolicyRoute
  ReportsRoute: typeof ReportsRoute
  ReviewsRoute: typeof ReviewsRoute
  SongsRoute: typeof SongsRoute
  TagsRoute: typeof TagsRoute
  UsersRoute: typeof UsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tags': {
      id: '/tags'
      path: '/tags'
      fullPath: '/tags'
      preLoaderRoute: typeof TagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/songs': {
      id: '/songs'
      path: '/songs'
      fullPath: '/songs'
      preLoaderRoute: typeof SongsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reviews': {
      id: '/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof ReviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policy': {
      id: '/policy'
      path: '/policy'
      fullPath: '/policy'
      preLoaderRoute: typeof PolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ops': {
      id: '/ops'
      path: '/ops'
      fullPath: '/ops'
      preLoaderRoute: typeof OpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flags': {
      id: '/flags'
      path: '/flags'
      fullPath: '/flags'
      preLoaderRoute: typeof FlagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entitlements': {
      id: '/entitlements'
      path: '/entitlements'
      fullPath: '/entitlements'
      preLoaderRoute: typeof EntitlementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/badge-copy': {
      id: '/badge-copy'
      path: '/badge-copy'
      fullPath: '/badge-copy'
      preLoaderRoute: typeof BadgeCopyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/attribution-disputes': {
      id: '/attribution-disputes'
      path: '/attribution-disputes'
      fullPath: '/attribution-disputes'
      preLoaderRoute: typeof AttributionDisputesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/announcements': {
      id: '/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AnnouncementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsRoute: AnalyticsRoute,
  AnnouncementsRoute: AnnouncementsRoute,
  AttributionDisputesRoute: AttributionDisputesRoute,
  AuditRoute: AuditRoute,
  BadgeCopyRoute: BadgeCopyRoute,
  EntitlementsRoute: EntitlementsRoute,
  FaqRoute: FaqRoute,
  FeedbackRoute: FeedbackRoute,
  FlagsRoute: FlagsRoute,
  LoginRoute: LoginRoute,
  OpsRoute: OpsRoute,
  PolicyRoute: PolicyRoute,
  ReportsRoute: ReportsRoute,
  ReviewsRoute: ReviewsRoute,
  SongsRoute: SongsRoute,
  TagsRoute: TagsRoute,
  UsersRoute: UsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
